import gettext from '../../lang/gettext';
import { addSuffix } from '../../utils';
import { SWAP_PENDING_STATUS } from '../../constants';

export function getOriginalShiftDescription(isOfferedByMe, offerer) {
  if (isOfferedByMe) {
    return gettext('You have offered to swap this shift');
  }

  return gettext('%(fullname)s has offered to swap this shift', { fullname: offerer.fullname });
}

export function getGoalShiftDescription(isOfferedToMe, offeree) {
  if (isOfferedToMe) {
    return gettext('with your shift');
  }
  return gettext('with %(fullname)s shift', { fullname: addSuffix(offeree.fullname) }); // @TODO gettextPossessive
}

export function getSwapStatusDescription(exchangeData, offeree, requireManagerApproval) {
  const { name: offereeName, fullname: offereeFullName } = offeree;
  const swapStatus = exchangeData.swap.status;

  if (swapStatus === SWAP_PENDING_STATUS) {
    return gettext(
      'This shift has been offered to %(offereeName)s.\nWaiting for %(offereePossesive)s reply.',
      { offereeName, offereePossesive: addSuffix(offereeName) }
    ); // @TODO gettextPossessive
  }
  const postfix = requireManagerApproval ? gettext("\nWaiting for manager's approval.") : '';
  if (exchangeData.amIOfferee) {
    return `${gettext('You have accepted this offer.')}${postfix}`;
  }

  return `${gettext('%(fullname)s has accepted this offer.', {
    fullname: offereeFullName,
  })}${postfix}`;
}
